import {
  createRouter as createVueRouter,
  createWebHistory,
} from 'vue-router'
import type { RouteRecordRaw, Router } from 'vue-router'

import routes from './routes/index.ts'
import { registerGuards } from './guards/index.ts'
import { baseUrl } from './location-params.ts'
import { setMeta } from '@/router/default-routes-meta.ts'

// HACK-VUE3
// It is designed for vue3 purposes. Just in case, we want to test this logic on vue2 only on development stage.
setMeta(routes)

// HACK-VUE3
function processParams (params: unknown): unknown {
  if (params && (typeof params === 'object' || Array.isArray(params))) {
    // Preserve Vue 2–era behavior: same shape as input (object vs array)
    const processedParams: Record<string, unknown> | unknown[] = Array.isArray(params) ? [] : {}
    for (const [key, value] of Object.entries(params as object)) {
      if ((typeof value === 'object' && value !== null) || Array.isArray(value)) {
        (processedParams as Record<string, unknown>)[key] = JSON.stringify(value)
      } else {
        (processedParams as Record<string, unknown>)[key] = value
      }
    }
    return processedParams
  }
  return params
}

type LegacyNavigationFn = (to: unknown, onComplete?: unknown, onAbort?: unknown) => unknown

export function createRouter (): Router {
  const router = createVueRouter({
    history: createWebHistory(baseUrl),
    routes: routes as RouteRecordRaw[],
    scrollBehavior () {
      return { top: 0 }
    },
  })

  // HACK-VUE3 — Vue 2–style (to, onComplete, onAbort) overload; keep runtime behavior
  const routerNav = router as unknown as { push: LegacyNavigationFn; replace: LegacyNavigationFn }
  const originalPush = router.push.bind(router) as LegacyNavigationFn
  routerNav.push = function (location, onComplete, onAbort) {
    if (location && typeof location === 'object' && location !== null && 'params' in location) {
      const loc = location as { params?: unknown }
      if (loc.params) {
        loc.params = processParams(loc.params)
      }
    }
    return originalPush(location, onComplete, onAbort)
  }

  const originalReplace = router.replace.bind(router) as LegacyNavigationFn
  routerNav.replace = function (location, onComplete, onAbort) {
    if (location && typeof location === 'object' && location !== null && 'params' in location) {
      const loc = location as { params?: unknown }
      if (loc.params) {
        loc.params = processParams(loc.params)
      }
    }
    return originalReplace(location, onComplete, onAbort)
  }

  registerGuards(router)

  return router
}

